import React, { ReactNode, useEffect, useRef } from 'react';
import ReactTooltip from 'react-tooltip';
import { useContextSelector } from 'use-context-selector';

import styles from './Tooltip.module.scss';
import { TooltipContext } from './TooltipContext';
import { isTooltipVisible } from './TooltipSelector';

type TooltipProps = {
  children: ReactNode;
  tooltip: string;
  top?: boolean;
  right?: boolean;
  left?: boolean;
  bottom?: boolean;
  id?: string;
  trigger?: 'manual';
  className?: string;
  blink?: boolean;
};

function Tooltip(props: TooltipProps) {
  const {
    children,
    tooltip,
    right,
    left,
    bottom,
    id,
    trigger,
    className = '',
    blink,
  } = props;
  const _className = [styles.Tooltip];
  const tooltipRef = useRef<HTMLSpanElement>(null);
  const visibleTooltips = useContextSelector(
    TooltipContext,
    (c) => c.visibleTooltips
  );

  const place = right ? 'right' : left ? 'left' : bottom ? 'bottom' : 'top';

  useEffect(() => {
    function detectVisibilityChanges() {
      if (trigger !== 'manual' || !id || !tooltipRef.current) return;

      if (isTooltipVisible(id, visibleTooltips)) {
        ReactTooltip.show(tooltipRef.current);
      } else {
        ReactTooltip.hide();
      }
    }

    detectVisibilityChanges();
  }, [id, trigger, visibleTooltips]);

  const tooltipHtml = blink
    ? `<div class="${styles.tooltipHtmlWrapper}"><div></div><span>${tooltip}</span></div>`
    : tooltip;

  return (
    <div className={_className.join(' ')}>
      <span data-for={id} data-tip={tooltipHtml} ref={tooltipRef}>
        {children}
      </span>
      <ReactTooltip
        id={id}
        getContent={!!id ? () => tooltipHtml : undefined}
        place={place}
        effect="solid"
        className={[
          styles.ReactTooltip,
          blink ? styles.ReactTooltip__html : '',
          className,
        ].join(' ')}
        multiline={true}
        event={trigger === 'manual' ? 'none' : undefined}
        // type="light"
        html={true}
      />
    </div>
  );
}

export default Tooltip;
